import Alpine from 'alpinejs';
import loaded from '@/scripts/helpers/loaded';
import BlazeSlider from 'blaze-slider';
import onKeyUpEscape from "@/scripts/helpers/onKeyUpEscape.js";
import "@/scripts/helpers/video.js";
import {customLightboxHTML, customSlideHTML} from "@/scripts/contants/glightbox.js";
import { syncVariant } from "@/scripts/helpers/productVariants.js";
import labelizeStampedImages from "@/scripts/helpers/labelizeStampedImages.js";
import fixBoostPriceAriaRole from "@/scripts/helpers/fixBoostPriceAriaRole.js";
import bypassOptinmonkContrast from "@/scripts/helpers/bypassOptinmonkContrast.js";
import patchThirdPartyA11y from "@/scripts/helpers/patchThirdPartyA11y.js";
import initEasifyAddToCart from "@/scripts/helpers/easifyAddToCart.js";
import iosViewportFix from "@/scripts/patches/iosViewportFix.js";

labelizeStampedImages();
fixBoostPriceAriaRole();
bypassOptinmonkContrast();
patchThirdPartyA11y();
initEasifyAddToCart();
iosViewportFix();

const hideLoader = () => {
    const overlay = document.getElementById('loaderOverlay');
    if (!overlay) {
        return;
    }

    overlay.style.display = 'none';
};

document.documentElement.className =
    document.documentElement.className.replace('no-js', 'js');

if (window.Shopify && Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

loaded(async () => {
    const popups = document.querySelectorAll('[data-popup]');
    if (!popups) {
        return;
    }

    if (!popups?.length) {
        return;
    }

    const { default: GLightbox } = await import('glightbox');
    if (!GLightbox) {
        return;
    }


    // Initialize GLightbox for video popups with selector-based approach
    const glightboxPopup = GLightbox({
        openEffect: 'fade',
        closeEffect: 'fade',
        selector: '[data-popup]',
        touchNavigation: true,
        loop: false,
        autoplayVideos: false,
        draggable: false,
        zoomable: false,
        svg: {
            close: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5 5 15M5 5l10 10"/></svg>',
            next: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 18 6-6-6-6"/></svg>',
            prev: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 18-6-6 6-6"/></svg>'
        },
        plyr: {
            config: {
                ratio: '16:9',
                hideControls: false,
                youtube: {
                    noCookie: true,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false
                }
            }
        },
        cssEffects: {
            // This are some of the animations included, no need to overwrite
            fade: {
                in: 'fadeIn',
                out: 'fadeOut'
            },
            zoom: {
                in: 'zoomIn',
                out: 'zoomOut'
            }
        },
        lightboxHTML: customLightboxHTML,
        slideHTML: customSlideHTML,
    });
});

loaded(() => {
    Alpine.data('combinedSlider', () => {
        return {
            productGalleryTrackElement: null,
            slides: null,
            productGallery: null,
            pageIndex: 0,
            activeSlide: 1,
            verticalSliderElement: null,
            canScrollUp: false,
            canScrollDown: true,

            init: async function () {
                const el = document.querySelector(".gallery-blaze-slider");
                this.productGallery = new BlazeSlider(el);
                el?.classList.add('is-blaze-loaded');
                this.productGalleryTrackElement = this.$el.querySelector(".blaze-track");
                this.slides = Array.from(this.productGalleryTrackElement.children);
                this.productGallery.onSlide(this.onSlide.bind(this));
                this.verticalSliderElement = this.$el.querySelector(
                    ".parent--images--smaller"
                );
                let visitedBefore = localStorage.getItem('visitedProductGallery');



                if (visitedBefore) {
                    hideLoader();
                } else {
                    const isMobile = window.matchMedia("(max-width: 768px)").matches;
                    const delay = isMobile ? 7000 : 2000;
                    setTimeout(() => hideLoader(), delay);
                }

                window.localStorage.setItem('visitedProductGallery', 'true');

                this.verticalSliderElement.addEventListener("scroll", () => {
                    this.updateNavigationVisibility();
                });

                this.$nextTick(() => {
                    this.updateNavigationVisibility();
                });

                window.addEventListener("resize", () => {
                    this.updateNavigationVisibility();
                });
            },

            onSlide: function (pageIndex) {
                this.pageIndex = pageIndex;
                this.activeSlide = pageIndex + 1;
                this.updateVerticalSliderPosition();
                this.updateActiveThumbnail();
                this.scrollToActiveThumbnail();
            },

            updateActiveThumbnail: function () {
                const thumbnails = Array.from(
                    this.$el.querySelectorAll(".item--images--smaller")
                );

                thumbnails.forEach((thumb) => thumb.classList.remove("active--item"));
                const currentThumbnail = thumbnails[this.pageIndex];
                if (currentThumbnail) {
                    currentThumbnail.classList.add("active--item");
                }
                this.scrollToActiveThumbnail(currentThumbnail);
            },

            scrollToActiveThumbnail: function () {
                const thumbnails = Array.from(this.verticalSliderElement.children);
                const activeThumb = thumbnails[this.pageIndex];
                if (activeThumb) {
                    activeThumb.scrollIntoView({behavior: "smooth", block: "nearest"});
                }
            },

            selectThumbnail: function (slideIndex) {
                const targetSlideIndex = slideIndex - 1;
                if (this.pageIndex !== targetSlideIndex) {
                    const difference = targetSlideIndex - this.pageIndex;
                    if (difference > 0) {
                        this.productGallery.next(difference);
                    } else {
                        this.productGallery.prev(-difference);
                    }
                }
                this.updateActiveThumbnail();
            },

            updateVerticalSliderPosition: function () {
                const imageHeight = 120;
                const desiredScrollTop = this.pageIndex * imageHeight;
                this.verticalSliderElement.scrollTo({
                    top: desiredScrollTop,
                    behavior: "smooth",
                });
            },

            setActiveSlide: function (event) {
                if (!event.isTrusted) return;
                const selectedOption = event.target.selectedOptions[0];
                const imageId = selectedOption.getAttribute("data-image-id");
                const targetImage = document.querySelector(
                    `.js__item__show--img[data-image-id="${imageId}"]`
                );
                if (targetImage) {
                    const slideIndex = Array.from(
                        targetImage.parentElement.children
                    ).indexOf(targetImage);
                    this.selectThumbnail(slideIndex + 1); // Using `this` here as it refers to the combined function scope
                }

                // Update variant price and availability
                const scope = document.querySelector('.parent--content--product__main') || document;
                syncVariant(scope);
            },

            scrollThumbnailsUp: function () {
                const scrollAmount = 120; // adjust based on your design
                const newScrollPosition =
                    this.verticalSliderElement.scrollTop - scrollAmount;
                this.verticalSliderElement.scrollTo({
                    top: newScrollPosition,
                    behavior: "smooth",
                });
                this.updateNavigationVisibility();
            },

            scrollThumbnailsDown: function () {
                const scrollAmount = 120; // adjust based on your design
                const newScrollPosition =
                    this.verticalSliderElement.scrollTop + scrollAmount;
                this.verticalSliderElement.scrollTo({
                    top: newScrollPosition,
                    behavior: "smooth",
                });
                this.updateNavigationVisibility();
            },

            updateNavigationVisibility: function () {
                this.canScrollUp = this.verticalSliderElement.scrollTop > 0;
                this.canScrollDown =
                    this.verticalSliderElement.scrollTop <
                    this.verticalSliderElement.scrollHeight -
                    this.verticalSliderElement.clientHeight;
            },
        };
    });

    Alpine.start();
});

loaded(() => {
    if (!document.querySelector('#preproduct-pledge')) return;

    const fix = () => {
        document.querySelectorAll('.tpo_product_price').forEach((el) => {
            const price = parseFloat(el.getAttribute('content'));
            const displayed = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
            if (price > 0 && displayed === 0) {
                el.textContent = `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
            }
        });

        const btn = document.querySelector('#pp-cleanslate');
        if (btn) {
            btn.style.setProperty('background', '#6fc051', 'important');
            btn.style.setProperty('border-color', '#6fc051', 'important');
        }

        const btnWidth = document.querySelector('.pp-button-width');
        if (btnWidth) {
            btnWidth.style.setProperty('background-color', '#6fc051', 'important');
        }

    };

    const interval = setInterval(fix, 200);
    setTimeout(() => clearInterval(interval), 10000);
});

// Fallback: if PreProduct hid add-to-cart buttons but failed to restore them, show them back
loaded(() => {
    const addToCartCustom = document.querySelector('#AddToCartCustom');
    if (!addToCartCustom) return;

    setTimeout(() => {
        const ppButton = document.querySelector('#pp-cleanslate');
        if (!ppButton && addToCartCustom.style.display === 'none') {
            addToCartCustom.style.display = '';
        }
    }, 3000);
});
